<template>
  <div class="nrbAboutTraining">
    <section class="section">
      <div class="container">
        <div class="container_1250">
          <div class="about_content about_training">
            <VueFaqAccordion :items="myItems" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'
//import UInput2 from "@/components/core/UInput2";

export default {
  name: 'chaldalFaq',
  components: {
    //UInput2,
    VueFaqAccordion,
  },

  data() {
    return {
      myItems: [
        {
          title: 'What is the duration of the course?\n',
          value:
            "The Intelligent Machines x Upskill's machine learning course is a 1.5 month-long program.\n",
          category: 'FAQ',
        },
        {
          title: 'What is the deadline for registration?\n',
          value: 'Registration closes on  April 22nd, 2021. \n',
          category: 'FAQ',
        },
        {
          title: 'What are the prerequisites for the course? \n',
          value:
            'Candidates are required to have knowledge of the fundamentals of statistics and math. \n',
          category: 'FAQ',
        },
        {
          title: 'How do I register for the course? \n',
          value: 'The registration form is available on this page.\n',
          category: 'FAQ',
        },
        {
          title: 'Do I have to pay for the course? \n',
          value:
            'You’ll only pay the fees to Upskill if you are hired by Intelligent Machines. You’ll make a five-installment payment of BDT 10,000/monthly. \n',
          category: 'FAQ',
        },
        {
          title:
            'Does course completion guarantee job placement at Intelligent Machines?\n',
          value:
            'No. Only a selected number of participants of the course will receive job placement at Intelligent Machines.',
          category: 'FAQ',
        },
        {
          title: 'What happens if I don’t get a job at Intelligent Machines?\n',
          value:
            'If you don’t get this job at Intelligent Machines, you will still be added to Upskill’s select pool of talent, which both local and global startups will hire from. \n',
          category: 'FAQ',
        },
        {
          title:
            'Do I receive the employee endorsed certificate regardless of placement at Intelligent Machines?\n',
          value:
            'Yes. Every participant who COMPLETES the machine learning course will receive an employee-endorsed certificate jointly issued by Upskill and Intelligent Machines. \n',
          category: 'FAQ',
        },
        {
          title: 'When are the classes scheduled?\n',
          value:
            'You will be informed of the class schedule on the day of orientation for the course.  The classes will likely be held after evening hours to accomodate existing job holders. \n',
          category: 'FAQ',
        },
        {
          title:
            'How much do I have to pay Upskill if I am hired by Intelligent Machines?\n',
          value:
            'You take part in the course free of cost. You’ll only pay the fees to Upskill if you are hired by Intelligent Machines. Afterwards, you’ll make  payment of BDT 50,000 (BDT 10,000/monthly installments) . \n',
          category: 'FAQ',
        },
        {
          title:
            'When will the security money of BDT 3,000 be returned back to me?\n',
          value:
            'The security money of BDT 3,000 you deposit before the start of the course, will be returned in full to you after you finish the course. \n',
          category: 'FAQ',
        },
        {
          title:
            'When will our job placements at Intelligent Machines take place?\n',
          value:
            'Application to the course + screening + course completion + assessment by IM + maximum of 3-month trainee program at IM at 30,000/month salary. After completion of these steps, you will be placed permanently into your job.\n',
          category: 'FAQ',
        },
        {
          title:
            'Do I have to do the trainee program as well if I already have a job?\n',
          value:
            'No. If you are currently a job holder, you WILL NOT be placed into the trainee program and will instead be directly placed into the job following completion of the previous steps in the timeline.\n',
          category: 'FAQ',
        },
      ],
      clone: [],
    }
  },
  methods: {
    search(e) {
      if (e == '') {
        this.myItems = this.clone
      } else {
        this.myItems = this.clone.filter(
          (o) => o.title.includes(e) || o.value.includes(e)
        )
      }
    },
  },
  created() {
    this.clone = this.myItems
  },
}
</script>
